export default [
    {
        path: '/',
        name: 'home',
        component: () => import('./components/main-view.vue'),
        meta: { 
            title: 'OneBuy',
            //layout: 'dashboard'
        }, 
    }
]